import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../api';

import { parseError } from '../utils/error-handler';

export const useQueryActivePayments = (locationId?: string) => {
  const apiClient = useApiClient();
  const query = useQuery({
    queryKey: ['active-payments', locationId],
    queryFn: async () => {
      return apiClient.ListActivePaymentController.listActivePaymentsV2({ locationId: locationId! }, {}).catch(
        parseError
      );
    },
    enabled: !!locationId,
    staleTime: 5 * 60 * 1000, // 5 min
  });

  return query;
};
